import BaseApiResponseModel from "api/model/BaseApiResponseModel";
import axios from "axios";
import ModelConverter from "utils/format/ModelConverter";
import IAPIClient from "./APIClient";
import { message } from "antd";
import AppConstants from "global/constants/AppConstants";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 60000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("LA");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    config.headers["ngrok-skip-browser-warning"] = `true`;
    return config;
  },
  (error) => Promise.reject(error),
);

//Response interceptors
api.interceptors.response.use(
  (response) => {
    return response?.data;
  },
  (error) => {
    console.log(error);

    if (error.code === "ECONNABORTED") {
      message.error("Yêu cầu mất quá nhiều thời gian, vui lòng thử lại sau!");
    }

    if (error?.response?.status == 403) {
      localStorage.clear();
      window.location.href = "/sign-in"; //relative to domain
    }

    if (error?.response?.status == 421) {
      message.error("Tính năng đang được bảo trì, vui lòng thử lại sau!");
    }

    if (error?.response?.status == 401) {
      localStorage.clear();
      window.location.href = "/sign-in";
    }

    if (error?.response?.status == 413) {
      message.error(AppConstants.FILE_LARGE);
    }
    return Promise.resolve(error?.response?.data);
  },
);

class AxiosClient implements IAPIClient {
  async post<T extends Object>(
    path: string,
    data: Map<string, any> | any = {},
    config: Map<string, any> | any = {},
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.post(path, data, config);
    return ModelConverter.decode(response, BaseApiResponseModel<T>);
  }

  async get<T extends Object>(
    path: string,
    data: Map<string, any> | any = {},
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.get(path, {
      params: data,
    });
    return ModelConverter.decode(response, BaseApiResponseModel<T>);
  }

  async delete<T extends Object>(
    path: string,
    data: any = {},
    options?: { useBody?: boolean },
  ): Promise<BaseApiResponseModel<T>> {
    let response;

    if (options?.useBody) {
      //send data body json
      response = await api.delete(path, { data });
    } else {
      response = await api.delete(path, { params: data });
    }

    return ModelConverter.decode(response, BaseApiResponseModel<T>);
  }

  async put<T extends Object>(
    path: string,
    data: Map<string, any> | any = {},
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.put(path, data);
    return ModelConverter.decode(response, BaseApiResponseModel<T>);
  }

  async getDownload(
    path: string,
    data: Map<string, any> | any = {},
  ): Promise<Blob> {
    const token = localStorage.getItem("LA");
    const response = await axios.get(path, {
      params: data,
      responseType: "blob",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response.data;
  }

  async patch<T extends Object>(
    path: string,
    data: Map<string, any> | any = {},
    config: Map<string, any> | any = {},
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.patch(path, data, config);
    return ModelConverter.decode(response, BaseApiResponseModel<T>);
  }
}

export default new AxiosClient();
